import { Loader2, RotateCw } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from "@/components/ui/alert-dialog";
import { usePoll } from "@/hooks/usePoll";
import { API, api, admin, errMsg } from "@/lib/api";
import { fmtDateTime } from "@/lib/format";
import { SecretField } from "./SecretField";

export const ApiKeyTab = ({ pw }) => {
  const { data, refresh } = usePoll(() => api.get("/admin/api-key", admin(pw)).then((r) => r.data), 0, [pw]);
  const [busy, setBusy] = useState(false);
  const rotate = async () => {
    setBusy(true);
    try {
      await api.post("/admin/api-key/rotate", null, admin(pw));
      toast.success("Master key rotated. Update your internal clients.");
      refresh();
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="space-y-4 pt-3" data-testid="apikey-tab">
      <SecretField label="Master API key (send as X-API-Key header)" value={data?.api_key} testid="master-api-key" />
      <div className="font-mono text-[11px] text-slate-500">Last rotated {fmtDateTime(data?.rotated_at)}</div>
      <pre className="scroll-thin overflow-x-auto rounded border border-slate-800 bg-slate-950 p-3 font-mono text-[11px] text-slate-400">
{`curl -H "X-API-Key: <master key>" \\
  "${API}/symbols/NSE:RELIANCE/snapshot"`}
      </pre>
      <AlertDialog>
        <AlertDialogTrigger asChild>
          <Button data-testid="rotate-api-key-button" variant="outline" className="border-amber-800 bg-transparent text-amber-300 hover:bg-amber-950/40">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <><RotateCw className="mr-1.5 h-4 w-4" /> Rotate master key</>}
          </Button>
        </AlertDialogTrigger>
        <AlertDialogContent className="border-slate-800 bg-[#0E1420]">
          <AlertDialogHeader>
            <AlertDialogTitle>Rotate the master API key?</AlertDialogTitle>
            <AlertDialogDescription>The current key stops working immediately for every internal client.</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="rotate-cancel">Cancel</AlertDialogCancel>
            <AlertDialogAction data-testid="rotate-confirm" onClick={rotate} className="bg-amber-600 hover:bg-amber-500">Rotate</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
};
